// extracted by mini-css-extract-plugin
export default {"hideFooter":"stateModal_hideFooter__3IW8F"};